import { Component, OnInit } from '@angular/core';
import { BsAppLaunchFormService } from '../../services/bs-app-launch-form.service';
import { CheckBoxFormControl } from './checkbox.control';
import { BsAppLaunchFormControlBaseComponent } from '../bs-app-launch-form-control-base.component';

@Component({
  selector: 'app-bs-app-launch-checkbox-control',
  templateUrl: './bs-app-launch-checkbox-control.component.html',
  styleUrls: ['./bs-app-launch-checkbox-control.component.scss']
})
export class BsAppLaunchCheckboxControlComponent extends BsAppLaunchFormControlBaseComponent<CheckBoxFormControl> implements OnInit {
  formControl: CheckBoxFormControl;

  constructor(bsAppLaunchFormService: BsAppLaunchFormService) {
    super(bsAppLaunchFormService);
  }

  ngOnInit() {
    this.toggle();
  }

  updatedSelectedChoices(index: number, checked: boolean): void {
    this.formControl.choices[index].checked = checked;

    const updatedSelectedValues = this.formControl.choices
      .filter((choice) => !!choice.checked)
      .map((choice) => choice.value);

    this.formControl.setValue(updatedSelectedValues);
    this.toggle();

    // Check if value changed and emit
    this.checkAndFireFormUpdate();
  }

}
